// extracted by mini-css-extract-plugin
export default {"Icon":"Icons_Icon__QsWzz","button-first":"Icons_button-first__tY29h","button-second":"Icons_button-second__d9U7x","button-single":"Icons_button-single__t7QHa"};